import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GlobalNotificationPanelService } from './global-notification-panel.service';

@Component({
    selector: 'app-global-notification-panel',
    templateUrl: './global-notification-panel.component.html',
    styleUrls: ['./global-notification-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalNotificationPanelComponent {
  globalNotificationPanelService = inject(GlobalNotificationPanelService);

  hide = () => {
    this.globalNotificationPanelService.hideGlobalNotificationPanel();
  };
}
